import { useMemoSelector } from '@spa/redux/hooks'

import { getAccountPermissions } from '../selectors'

export const useAccountPermissions = () =>
  useMemoSelector(getAccountPermissions)
